module.exports = __webpack_public_path__ + "static/media/wordmark-2.06d6db77.svg";